/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Field } from 'react-final-form';
import { Text } from '@blend/enterprise-components';

import { BlendBridge } from 'blb-types/blendBridge';
import { respondToAuthChallenge } from 'blb-api/auth';
import { FormCard } from 'blb-components/FormCard';
import { SetUser } from 'blb-ui-types/login';
import { useLoginFlowSubmit, useChallengeCookie } from 'blb-utils/login';
import { getConfirmationCodeInputConfig } from 'blb-utils/inputs';

const confirmationCodeInputConfig = getConfirmationCodeInputConfig({ name: 'mfaCode' });

export namespace PhoneMFAPage {
  export interface Props {
    setMe: SetUser;
  }
}

export const PhoneMFAPage: React.FC<PhoneMFAPage.Props> = ({ setMe }) => {
  const onSubmit = useLoginFlowSubmit(respondToAuthChallenge, setMe);
  const challengeCookieResult = useChallengeCookie();
  const last4Digits = (() => {
    if (challengeCookieResult.type === 'failure' || challengeCookieResult.cookie.challengeName !== 'SMS_MFA') {
      return null;
    }
    const { phoneNumberLastFour } = challengeCookieResult.cookie.meta;
    return phoneNumberLastFour;
  })();

  return (
    <FormCard<BlendBridge.API.MFAChallenge>
      headerLabel={
        <Text>
          A text message with your code has been sent to the phone number ending with{' '}
          <Text weight="semibold">{last4Digits}</Text>
        </Text>
      }
      headerTitle="Enter verification code"
      id="PhoneMFA"
      onSubmit={onSubmit}
      submitLabel="Log in"
    >
      <Field {...confirmationCodeInputConfig} />
    </FormCard>
  );
};
